import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { TranslocoService } from '@ngneat/transloco';
import { AuthService } from 'src/app/service/auth.service';
import { ProjectService } from 'src/app/service/project.service';

@Component({
  selector: 'app-shared-archives',
  templateUrl: './shared-archives.component.html',
  styleUrls: ['./shared-archives.component.css']
})
export class SharedArchivesComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();


  notifications: any[] = []
  listSharedArchives: any[] = []
  userId: string;
  loadingShareArchives: boolean = false
  isLoading: boolean = false

  constructor(
    private projectService: ProjectService,
    private authService: AuthService,
    private messageService: MessageService,
    private translocoService: TranslocoService,
    private titleService: Title

  ) {
    this.userId = this.authService.getUserInformations()
  }

  ngOnInit() {
    this.setTitle();
    this.getSharedArchivesList()
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setTitle() {
    this.translocoService
      .selectTranslate("title.shared-with-me")
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => this.titleService.setTitle(value));
  }

  getSharedArchivesList() {
  this.loadingShareArchives = true;
  this.isLoading = true
  this.projectService
    .GetSharedArchives(this.userId, true, 1, 5)
    .subscribe((response) => {
      if (response.status === 200 && response.body?.listItens) {
        const notificationList = response.body.listItens;

        const newNotification = notificationList.filter((item: any) => {
          return (
            !item.sharingAccepted &&
            !this.notifications.some((n) => n.id === item.id)
          );
        });

        if (newNotification.length > 0) {
          this.notifications.push(...newNotification);
        }

        this.notifications = this.notifications
          .filter((notificacao) => {
            const matchingItem = notificationList.find((item: any) => item.id === notificacao.id);
            return matchingItem && !matchingItem.sharingAccepted;
          });

        this.listSharedArchives = notificationList.filter(
          (item: any) => item.sharingAccepted
        );

        this.loadingShareArchives = false;
        this.isLoading = false

      }
    });
}


acceptOrDeclineArchive(sharedID: string, paramAccepted: boolean) {
    this.isLoading = true
    this.projectService
      .RemoveSharedArchive(this.userId, sharedID, paramAccepted)
      .subscribe((response) => {
        if (response.status === 200) {
          this.messageService.clear();
          const message = paramAccepted
            ? this.translocoService.translate('messages.success.shareAccepted')
            : this.translocoService.translate('messages.success.shareCancelled');

          this.messageService.add({
            key: "toastProject",
            severity: "success",
            summary: this.translocoService.translate('common.labels.success'),
            detail: message,
          });
          this.getSharedArchivesList();
        }
        else {

          const errorMessage = paramAccepted
            ? this.translocoService.translate('messages.error.acceptShareError')
            : this.translocoService.translate('messages.error.cancelShareError');

          this.messageService.add({
            key: "toastProject",
            severity: "error",
            summary: this.translocoService.translate('common.labels.warning'),
            detail: errorMessage,
          });
        }
      });
  }

getTipoArquivo(type: string): string {
  switch (type) {
    case 'map': return this.translocoService.translate('sharedArchives.typeMap');
    case 'log': return this.translocoService.translate('sharedArchives.typeLog');
    default: return type;
  }
}


}
